export const bottomKidsTrackingFeatures = [
    {
        id: '1',
        title: 'Freedom Without Worry',
        content: 'We know that kids need independence and parents need reassurance. With a tracking app for kids, they get to do the things they want without you having to worry.',
        imgName: 'earth'
    },
    {
        id: '2',
        title: 'Instant Location in an Emergency',
        content: "If something goes wrong, you don’t have to wait for a response, just check their location.",
        imgName: 'checkCircleIcon'
    },
    {
        id: '3',
        title: 'Smoother School Runs & Pick-Ups',
        content: "Know exactly when your child leaves school or practice, so you’re never left guessing when to pick them up. You can also get Google Maps directions to their exact location from the app.",
        imgName: 'mobilePhoneIcon'
    },
    {
        id: '4',
        title: 'A Backup Plan for Forgotten Phones',
        content: "Children can be forgetful, especially with their phones. If they leave it behind, you can track it down easily from your device, saving time and stress.",
        imgName: 'eye'
    },
];